import { loadStripe } from "@stripe/stripe-js";
import {
  initializeAnalytics,
  deInitializeAnalytics,
} from "@/lib/google-analytics";

export function hasConsent(serviceName: string): boolean {
  if (typeof window === "undefined") return false;
  if (!window.klaro?.getManager) return false;

  try {
    const manager = window.klaro.getManager();
    return manager.consents[serviceName] === true;
  } catch (e) {
    console.error("Error getting consent:", e);
    return false;
  }
}

// Stripe
let stripeInstance: any = null;
const initializeStripe = async () => {
  if (!process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY) return null;
  return await loadStripe(process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY);
};

export async function loadServicesBasedOnConsent() {
  if (typeof window === "undefined") return;

  if (hasConsent("stripe") && !stripeInstance) {
    stripeInstance = await initializeStripe();
  }

  if (hasConsent("google-analytics")) {
    initializeAnalytics();
  } else {
    deInitializeAnalytics();
  }
}

export function setupConsentListeners() {
  if (typeof window === "undefined" || !window.klaro?.getManager) return;

  window.klaro.getManager().watch({
    update: (_: any, name: string, consents: Record<string, boolean>) => {
      if (name === "consents") {
        loadServicesBasedOnConsent();
      }
    },
  });
}

export const getStripe = () => stripeInstance;
